var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGlobalWhiteS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24.35C20.1639 24.35 24.35 20.1639 24.35 15C24.35 9.83614 20.1639 5.65 15 5.65C9.83614 5.65 5.65 9.83614 5.65 15C5.65 20.1639 9.83614 24.35 15 24.35ZM15 26C21.0751 26 26 21.0751 26 15C26 8.92487 21.0751 4 15 4C8.92487 4 4 8.92487 4 15C4 21.0751 8.92487 26 15 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0907 17.3432C23.9644 16.5767 24.35 15.8165 24.35 15.5C24.35 15.1835 23.9644 14.4233 22.0907 13.6568C20.3611 12.9493 17.8558 12.4727 15 12.4727C12.1442 12.4727 9.63889 12.9493 7.90931 13.6568C6.03559 14.4233 5.65 15.1835 5.65 15.5C5.65 15.8165 6.03559 16.5767 7.90931 17.3432C9.63889 18.0507 12.1442 18.5273 15 18.5273C17.8558 18.5273 20.3611 18.0507 22.0907 17.3432ZM15 20C21.0751 20 26 17.9853 26 15.5C26 13.0147 21.0751 11 15 11C8.92487 11 4 13.0147 4 15.5C4 17.9853 8.92487 20 15 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5424 22.0907C13.5645 23.9644 14.578 24.35 15 24.35C15.422 24.35 16.4355 23.9644 17.4576 22.0907C18.401 20.3611 19.0364 17.8558 19.0364 15C19.0364 12.1442 18.401 9.63888 17.4576 7.90931C16.4355 6.03559 15.422 5.65 15 5.65C14.578 5.65 13.5645 6.03559 12.5424 7.90931C11.599 9.63888 10.9636 12.1442 10.9636 15C10.9636 17.8558 11.599 20.3611 12.5424 22.0907ZM9 15C9 21.0751 11.6863 26 15 26C18.3137 26 21 21.0751 21 15C21 8.92487 18.3137 4 15 4C11.6863 4 9 8.92487 9 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobalWhiteS);
export default __webpack_public_path__ + "static/media/ic_global_white_s.2a669500b7dabe104a695fdc171adb38.svg";
export { ForwardRef as ReactComponent };